var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GroupRules',{attrs:{"rules":_vm.rules,"odds":_vm.odds,"provider":_vm.provider,"projections":_vm.projections,"slate":_vm.slate},on:{"delete-rule":_vm.deleteRule,"add-rule":_vm.addRule}})
}
var staticRenderFns = []

export { render, staticRenderFns }